import { useQuery } from '@tanstack/react-query';
import { authService } from '../../services/authService';
import { queryKeys } from '../../lib/queryKeys';
import { apiJson } from './apiFetch';
import { useCampaignStore } from '../../stores';
import type { ContactRateDto } from '@signalvote/shared';

/**
 * Fetch contact rates for all active walkbooks in the current campaign.
 * Used by the Turf Contact Rate overlay (VMF-007).
 */
export function useWalkbookContactRates() {
  const { selectedCampaign } = useCampaignStore();

  return useQuery({
    queryKey: queryKeys.walkbooks.contactRates(),
    queryFn: (): Promise<ContactRateDto[]> =>
      apiJson<ContactRateDto[]>('/api/walkbooks/contact-rates', {
        error: 'Failed to fetch walkbook contact rates',
      }),
    enabled: !!selectedCampaign && authService.isAuthenticated(),
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
}
